import React from 'react'

import { useSearchParams } from 'react-router-dom'

import moment from 'moment'

import { useTranslation } from 'react-i18next'

import { IPlanMenuCloseDimensionDto } from 'core/api/dto/PlanMenuCloseDto'

interface IFrozeItemProps {
  dimensionItem: IPlanMenuCloseDimensionDto
  index: number
  withTaskAddButton?: boolean
}

export const FrozeCloseItem = ({
  dimensionItem,
  index,
  withTaskAddButton,
}: IFrozeItemProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentDimensionId = searchParams.get('dimension')?.split('_')[0] || 0
  const onDimensionHandler = () => {
    searchParams.set('dimension', `${dimensionItem.id}`)
    searchParams.set('index', `${index}`)
    setSearchParams(searchParams.toString())
  }

  return (
    <div
      className={`froze-item${
        dimensionItem.id === Number(currentDimensionId || 0) ? ' active' : ''
      } froze-item-close`}
      onClick={onDimensionHandler}
    >
      <div className="number">
        <span>{index}</span>
      </div>
      <div className="froze-info">
        <div className="">
          {!!dimensionItem.milletType.isDefault && (
            <div className="flex-end">
              <div className={`status-block-item`}>
                <span>{t(`Назначить тару`)}</span>
              </div>
            </div>
          )}

          <div className="froze">
            <span>{t('Замер')}</span>
            <div className="dotes" />
            <span>
              <b>{moment(dimensionItem.dimensionDatetime).format('HH:mm')}</b>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
